import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import resourcesToBackend from 'i18next-resources-to-backend'
// EVERY language (en included) loads through the resourcesToBackend dynamic
// import below — each is its own chunk instead of JSON riding in the entry
// bundle. Root (main.tsx) gates first render on the initial language load so
// users never see raw keys. Do NOT import './locales/en' or the root
// './locales' barrel here: that would statically link locale data back into
// the entry.

// Helper: normalize language code to our supported set
export const normalize = (lng?: string) => {
  if (!lng) return 'en'
  const low = lng.toLowerCase()
  if (low.startsWith('ne')) return 'ne'
  if (low.startsWith('hi')) return 'hi'
  return 'en'
}

void i18n
  .use(LanguageDetector)
  .use(
    resourcesToBackend((language: string) =>
      import(`./locales/${language}/index.ts`).then((m) => m.default),
    ),
  )
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: 'en', // default; detector/geo may override
    interpolation: { escapeValue: false },
    detection: {
      // order: try localStorage, then querystring (?lng=ne), then navigator
      order: ['localStorage', 'querystring', 'navigator'],
      lookupQuerystring: 'lng',
      caches: ['localStorage']
    },
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (lngs, _ns, key) => {
      if (import.meta.env.DEV) {
        // eslint-disable-next-line no-console
        console.warn(
          `[i18n] Missing key "${key}" for language(s) ${Array.isArray(lngs) ? lngs.join(",") : lngs}.`,
        );
      }
    },
  })

// Keep <html lang> in sync for fonts, A11y, SEO
export function syncHtmlLang(current = i18n.language) {
  const normalized = normalize(current)
  let lang = 'en'
  if (normalized === 'ne') lang = 'ne-NP'
  else if (normalized === 'hi') lang = 'hi-IN'
  
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', lang)
  }
}

// update <html lang> whenever language changes
i18n.on('languageChanged', syncHtmlLang)

export default i18n
